import type { ValueOf } from 'type-fest';

export enum FrequencyEnum {
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  DAILY = 'DAILY',
}
export type Frequency = ValueOf<typeof FrequencyEnum>;

export enum AliasEnum {
  ONE_TIME_PAYMENT = 'ONE_TIME_PAYMENT',
  EVERY_YEAR = 'EVERY_YEAR',
  EVERY_X_YEARS = 'EVERY_X_YEARS',
  MULTIPLE_FIXED_DATES = 'MULTIPLE_FIXED_DATES',
  EVERY_WEEK = 'EVERY_WEEK',
  EVERY_X_WEEKS = 'EVERY_X_WEEKS',
  EVERY_MONTH = 'EVERY_MONTH',
  EVERY_X_MONTHS = 'EVERY_X_MONTHS',
  TWICE_A_MONTH = 'TWICE_A_MONTH',
  EVERY_X_DAYS = 'EVERY_X_DAYS',
  EVERY_QUARTER = 'EVERY_QUARTER',
}
export type Alias = ValueOf<typeof AliasEnum>;
